import * as React from 'react';
import AddIcon from './svgs/AddIcon';
import ArrowRightIcon from './svgs/ArrowRightIcon';
import CaretDoubleIcon from './svgs/CaretDoubleIcon';
import CaretIcon from './svgs/CaretIcon';
import CheckmarkIcon from './svgs/CheckmarkIcon';
import CheckmarkMixedIcon from './svgs/CheckmarkMixedIcon';
import CircleIcon from './svgs/CircleIcon';
import CircleCompleteIcon from './svgs/CircleCompleteIcon';
import CircleExclamationIcon from './svgs/CircleExclamationIcon';
import CircleInfoIcon from './svgs/CircleInfoIcon';
import CircleWarnIcon from './svgs/CircleWarnIcon';
import CloseIcon from './svgs/CloseIcon';
import ConnectBothIcon from './svgs/ConnectBothIcon';
import ConnectPullIcon from './svgs/ConnectPullIcon';
import ConnectPushIcon from './svgs/ConnectPushIcon';
import DotsIcon from './svgs/DotsIcon';
import DownloadIcon from './svgs/DownloadIcon';
import ExclamationIcon from './svgs/ExclamationIcon';
import EyeIcon from './svgs/EyeIcon';
import GearIcon from './svgs/GearIcon';
import FileAddedIcon from './svgs/FileAddedIcon';
import FileFolderClosedIcon from './svgs/FileFolderClosedIcon';
import FileFolderOpenedIcon from './svgs/FileFolderOpenedIcon';
import FileLeftArrowIcon from './svgs/FileLeftArrowIcon';
import FileLockedIcon from './svgs/FileLockedIcon';
import FileRightArrowIcon from './svgs/FileRightArrowIcon';
import FileUnlockedIcon from './svgs/FileUnlockedIcon';
import PlayIcon from './svgs/PlayIcon';
import PushIcon from './svgs/PushIcon';
import OfflineIcon from './svgs/OfflineIcon';
import RefreshIcon from './svgs/RefreshIcon';
import SearchIcon from './svgs/SearchIcon';
import SpinnerIcon from './svgs/SpinnerIcon';
import StarIcon from './svgs/StarIcon';
import StopIcon from './svgs/StopIcon';

/**
 * Namespace of Icons that can be imported once and reference multiple icons: `Icons.Add`.
 * Note: the name of the exported const should match the filename with the `Icon` suffix removed.
 */
namespace Icons {
	export const Add = AddIcon;
	export const ArrowRight = ArrowRightIcon;
	export const CaretDouble = CaretDoubleIcon;
	export const Caret = CaretIcon;
	export const Checkmark = CheckmarkIcon;
	export const CheckmarkMixed = CheckmarkMixedIcon;
	export const Circle = CircleIcon;
	export const CircleComplete = CircleCompleteIcon;
	export const CircleExclamation = CircleExclamationIcon;
	export const CircleInfo= CircleInfoIcon;
	export const CircleWarn = CircleWarnIcon;
	export const Close = CloseIcon;
	export const ConnectBoth = ConnectBothIcon;
	export const ConnectPull = ConnectPullIcon;
	export const ConnectPush = ConnectPushIcon;
	export const Dots = DotsIcon;
	export const Download = DownloadIcon;
	export const Exclamation = ExclamationIcon;
	export const Eye = EyeIcon;
	export const FileAdded = FileAddedIcon;
	export const FileFolderClosed = FileFolderClosedIcon;
	export const FileFolderOpened = FileFolderOpenedIcon;
	export const FileLeftArrow = FileLeftArrowIcon;
	export const FileLocked = FileLockedIcon;
	export const FileRightArrow = FileRightArrowIcon;
	export const FileUnlocked = FileUnlockedIcon;
	export const Gear = GearIcon;
	export const Offline = OfflineIcon;
	export const Play = PlayIcon;
	export const Push = PushIcon;
	export const Refresh = RefreshIcon;
	export const Search = SearchIcon;
	export const Spinner = SpinnerIcon;
	export const Stars = StarIcon;
	export const Stop = StopIcon;
}

/**
 * Individually exported icons.
 * Note: the name of the exported component should include the `Icon` suffix.
 */
export {
	Icons, // export the namespace 'Icons' here
	AddIcon,
	ArrowRightIcon,
	CaretDoubleIcon,
	CaretIcon,
	CheckmarkIcon,
	CheckmarkMixedIcon,
	CircleIcon,
	CircleCompleteIcon,
	CircleExclamationIcon,
	CircleInfoIcon,
	CircleWarnIcon,
	CloseIcon,
	ConnectBothIcon,
	ConnectPullIcon,
	ConnectPushIcon,
	DotsIcon,
	DownloadIcon,
	ExclamationIcon,
	EyeIcon,
	FileAddedIcon,
	FileFolderClosedIcon,
	FileFolderOpenedIcon,
	FileLeftArrowIcon,
	FileLockedIcon,
	FileRightArrowIcon,
	FileUnlockedIcon,
	GearIcon,
	OfflineIcon,
	PlayIcon,
	PushIcon,
	RefreshIcon,
	SpinnerIcon,
	StarIcon,
	StopIcon,
}
